export default {"src":"/_next/static/image/public/images/Exciting_offers.6d429eca5c0c8617cbb4ddc3fedeb765.svg","height":106,"width":180};